<script>
    import {mediaUrlStore, publishConfigStore, tenantKeyStore} from "../core/app-store.js";
    import WidgetYandexBusiness from "./WidgetYandexBusiness.svelte";
    import {get} from "svelte/store";

    const mediaUrl = get(mediaUrlStore)
    const originalUrl = `${mediaUrl}${$tenantKeyStore}${$publishConfigStore.headerImage}`;

    /**
     *
     * ...us/.../_header_files/..._1024.jpg
     *
     * @param imagePath - /_header_files/file-name.jpg
     * @param width - 1024
     * @returns {string} - .us/ABC/_header_files/file-name_1024.jpg
     */
    function getImageUrl(imagePath, width) {

        if (width) {
            const resizedPath = imagePath.replace(/\.(jpg|jpeg|png|webp)$/, `_${width}.$1`);
            return `${mediaUrl}${$tenantKeyStore}${resizedPath}`;
        }

        return `${mediaUrl}${$tenantKeyStore}${imagePath}`;
    }

    function handleImageError(event) {
        event.target.src = originalUrl;
        event.target.onerror = null; // Prevent infinite loop
    }

    /**
     * ...us/.../_header_files/..._480.jpg 480w,
     * ...us/.../_header_files/..._768.jpg 768w,
     * ...us/.../_header_files/..._1024.jpg 1024w,
     * ...us/.../_header_files/..._1600.jpg 1600w,
     * ...us/.../_header_files/....jpg 1920w
     */

    $: headerImageSrcset = $publishConfigStore.headerImage ? `
        ${getImageUrl($publishConfigStore.headerImage, 480)} 480w,
        ${getImageUrl($publishConfigStore.headerImage, 768)} 768w,
        ${getImageUrl($publishConfigStore.headerImage, 1024)} 1024w,
        ${getImageUrl($publishConfigStore.headerImage, 1600)} 1600w,
        ${originalUrl} 1920w
    ` : '';

    $: headerImageSizes = "(max-width: 480px) 480px, (max-width: 768px) 768px, (max-width: 1024px) 1024px, (max-width: 1600px) 1600px, 1920px";
</script>

<style>

    header {
        background: var(--header-background);
    }

    .content {
        display: flex;
        flex-direction: column;
        gap: 20px;
        padding: 0 16px;
    }

    .header {
        display: flex;
        flex-direction: column;
        gap: 1.5rem;
    }
    h1 {
        font-size: 56px;
        color: var(--accent-color);
        line-height: .95em;
        max-width: 100%;
        overflow-wrap: break-word;
    }
    .header .header-image {
        position: relative;
        display: block;
        background: var(--bg-color);
        width: 100%;
        height: 60vh;
        overflow: hidden;
    }
    .header .header-image img {
        object-fit: cover;
    }
    .header--no-image {
        padding-top: 5vh;
    }
    .header .header-image-overlay {
        background: linear-gradient(0deg, #00000059, transparent);
        height: 10vh;
        position: absolute;
        z-index: 1000000;
        width: 100%;
        bottom: 0;
    }
    .info-container {
        position: absolute;
        width: 100%;
        bottom: 0;
        align-items: flex-start; 
        z-index: 1000000;
        padding-bottom: 1.25rem;
    }

    .yb-widget-container {
        margin: 0 1.25rem;
        border-radius: .5rem;
        overflow: hidden;
    }

    .header-text {
        z-index: 100;
        display: flex;
        align-items: flex-end;
        justify-content: center;
        padding: 0 1.25rem;
        opacity: 1;
        animation: header-text-anim .3s ease 1s 1 normal forwards;
    }
    .header-text span {
        background: var(--bg-second-color);
        width: fit-content;
        text-transform: uppercase;
        border: none;
        color: var(--main-font-color);
        font-family: "PT Mono", sans-serif;
        font-size: 12px;

        padding: 0.35rem 0.7rem;
        line-height: 125%;
        border-radius: 1rem;
        text-align: left;
    }

    .header-text--dark span {
        color: rgba(1, 1, 1, 1);
        background: rgba(255, 255, 255, 0.5);
    }
    .header-text--green span {
        color: rgba(97, 255, 110, 0.8);
    }
    .header-text--blue span {
        color: rgba(125, 180, 255,.8);
    }
    .header-text--orange span {
        color: var(--accent-color);
    }
    .header-text--red span {
        color: rgba(255, 101, 101, 0.8);
    }
    .rest-desc {
        white-space: break-spaces;
        padding: 0;
        margin: 0;
        font-family: Roboto, sans-serif;
        font-size: 20px;
        color: var(--secondary-font-color);
    }

    .header-text--top {align-items: flex-start;}
    .rest-phones {
        padding: 0 1rem 1.5rem 1rem;
        margin: 0;
        display: flex;
        gap: 16px;
        width: 100%;
        overflow-y: auto;
    }
    .phone-btn {

        font-family: Roboto Condensed, sans-serif;
        text-transform: uppercase;
        font-size: 16px;
        font-weight: 800;
        white-space: nowrap;

        color: var(--main-font-color);
        border: 1px solid var(--main-font-color);

        text-decoration: none;
        border-radius: 2rem;
        padding: 8px 16px;
        display: flex;
        align-items: center;
        gap: .5em;
    }

    .phone-btn--text {
        border: none;
        color: var(--main-font-color);
        margin-left: -16px;
    }
    .phone-btn svg {
        line-height: 1;
        vertical-align: middle;
    }

    @keyframes header-text-anim {
        from {
            top: 1rem;
            opacity: .2;
        }
        to {
            top: 0;
            opacity: 1;
        }
    }

    @media (min-width: 768px) {

        h1 {
            text-align: center;
        }
        .desktop-header {
            position: relative;
            height: 100vh;
        }
        .desktop-header-content {
            gap: 48px;
            height: 100%;
            padding-top: 25vh;
        }
        .desktop-header-content .header-text {
            position: relative;
        }
        .desktop-header-content h1 {
            font-family: Roboto Condensed, sans-serif;
            font-size: 84px;
            font-weight: 900;
        }
        .desktop-header-content .rest-desc {
            white-space: break-spaces;
            text-align: center;
            text-transform: uppercase;
            color: var(--main-font-color);
            font-family: Roboto, sans-serif;
            font-weight: 300;
            line-height: 150%;
        }

        .desktop-header-content .rest-phones {
            justify-content: center;
            padding-bottom: 0;
        }
        
        .desktop-header-image {
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            height: 100%;
            overflow: hidden;
            z-index: -2;
        }
        .desktop-header-image img {
            position: relative;
            object-fit: cover;
            object-position: center center;
            width: 100%;
            height: 100%;
        }
        .desktop-header-image-effect {
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            background: radial-gradient(rgba(0,0,0,0.2), rgba(0,0,0,0.6));
            z-index: -1;
        }
        .yb-widget-container--desktop {
            position: absolute;
            margin: 0;
            bottom: unset;
            top: 1rem;
            left: 50%;
            transform: translateX(-50%);
        }
    }
</style>

<!-- HEADER -->
<header class="layer-sections">

    <!-- DESKTOP -->
    <div class="desktop-header hide-on-mobile flex-column jc-center ai-center">

        {#if ( ($publishConfigStore.headerImage || '').length > 0 )}
            <div class="desktop-header-image">
                <img srcset={headerImageSrcset}
                     sizes={headerImageSizes}
                     src={getImageUrl($publishConfigStore.headerImage, 1920)}
                     loading="lazy"
                     alt={$publishConfigStore.restaurantName}
                     onerror={(e) => handleImageError(e)}>
            </div>
            <div class="desktop-header-image-effect"></div>
        {/if}

        {#if $publishConfigStore.ybId}
            <div class="yb-widget-container yb-widget-container--desktop flex jc-center">
                <WidgetYandexBusiness
                        ybId={$publishConfigStore.ybId}
                        ybWidgetTheme={$publishConfigStore.ybWidgetTheme}
                />
            </div>
        {/if}

        <div class="desktop-header-content container_768 container_960 container_1600 flex-column jc-center ai-center">

            {#if ($publishConfigStore.headerTexts?.length > 0 && $publishConfigStore.headerTexts[0].text?.length)}
                <div class="header-text header-text--paddings-no header-text--top header-text--center
                        {$publishConfigStore.headerTexts[0].colors === 'black-white' ? 'header-text--dark' : $publishConfigStore.headerTexts[0].colors === 'red' ? 'header-text--red' : $publishConfigStore.headerTexts[0].colors === 'blue' ? 'header-text--blue' : $publishConfigStore.headerTexts[0].colors === 'green' ? 'header-text--green' : $publishConfigStore.headerTexts[0].colors === 'orange' ? 'header-text--orange' : ''}
                        ">
                    <span>{ $publishConfigStore.headerTexts[0].text }</span>
                </div>
            {/if}

            <h1>{$publishConfigStore.restaurantName}</h1>

            {#if ($publishConfigStore.restaurantDescription)}
                <p class="rest-desc">{$publishConfigStore.restaurantDescription}</p>
            {/if}

            {#if ($publishConfigStore.headerActions)}
                <div class="rest-phones">
                    {#each $publishConfigStore.headerActions as action}

                        <a class="phone-btn"
                           class:phone-btn--text={action.link === undefined}
                           href="{ action.link }"
                           target="{ action.target }"
                           rel="nofollow noopener">

                            {#if (action.icon === 'phone')}
                                <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="ai ai-Phone"><path d="M10.554 6.24L7.171 2.335c-.39-.45-1.105-.448-1.558.006L2.831 5.128c-.828.829-1.065 2.06-.586 3.047a29.207 29.207 0 0 0 13.561 13.58c.986.479 2.216.242 3.044-.587l2.808-2.813c.455-.455.456-1.174.002-1.564l-3.92-3.365c-.41-.352-1.047-.306-1.458.106l-1.364 1.366a.462.462 0 0 1-.553.088 14.557 14.557 0 0 1-5.36-5.367.463.463 0 0 1 .088-.554l1.36-1.361c.412-.414.457-1.054.101-1.465z"/></svg>
                            {/if}
                            {#if (action.icon === 'location')}
                                <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="ai ai-Location"><circle cx="12" cy="10" r="3"/><path d="M12 2a8 8 0 0 0-8 8c0 1.892.402 3.13 1.5 4.5L12 22l6.5-7.5c1.098-1.37 1.5-2.608 1.5-4.5a8 8 0 0 0-8-8z"/></svg>
                            {/if}
                            {#if (action.icon === 'map')}
                                <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="ai ai-Map"><path d="M8.368 4.79l-2.736-.913A2 2 0 0 0 3 5.775v11.783a2 2 0 0 0 1.368 1.898l4 1.333a2 2 0 0 0 1.264 0l4.736-1.578a2 2 0 0 1 1.264 0l2.736.912A2 2 0 0 0 21 18.224V6.442a2 2 0 0 0-1.367-1.898l-4-1.333a2 2 0 0 0-1.265 0L9.631 4.789a2 2 0 0 1-1.264 0z"/><path d="M9 5v16"/><path d="M15 3v16"/></svg>
                            {/if}
                            {#if (action.icon === 'calendar')}
                                <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="ai ai-Calendar"><rect x="2" y="4" width="20" height="18" rx="4"/><path d="M8 2v4"/><path d="M16 2v4"/><path d="M2 10h20"/></svg>
                            {/if}

                            {#if (action.text && action.text.length > 0)}
                                <span>{ action.text }</span>
                            {/if}
                        </a>

                    {/each}
                </div>
            {/if}

        </div>

    </div>

    <!-- MOBILE -->
    <div class="header hide-on-desktop" class:header--no-image={($publishConfigStore.headerImage || '').length === 0}>

        {#if ( ($publishConfigStore.headerImage || '').length > 0 )}
            <div class="header-image" style:height="{$publishConfigStore.headerImageHeight || 60}vh">
                <div class="header-image-overlay"></div>
                <img class="full-width full-height"
                     srcset={headerImageSrcset}
                     sizes={headerImageSizes}
                     src={getImageUrl($publishConfigStore.headerImage, 1920)}
                     loading="lazy"
                     alt={$publishConfigStore.restaurantName}
                     onerror={(e) => handleImageError(e)}>

                <div class="info-container flex-column gap-05">
                    {#if $publishConfigStore.ybId}
                        <div class="yb-widget-container flex jc-center">
                            <WidgetYandexBusiness
                                    ybId={$publishConfigStore.ybId}
                                    ybWidgetTheme={$publishConfigStore.ybWidgetTheme}
                            />
                        </div>
                    {/if}

                    {#if ($publishConfigStore.headerTexts?.length > 0 && $publishConfigStore.headerTexts[0].text?.length)}
                        <div class="header-text header-text--paddings-no header-text--bottom header-text--center
                        {$publishConfigStore.headerTexts[0].colors === 'black-white' ? 'header-text--dark' : $publishConfigStore.headerTexts[0].colors === 'red' ? 'header-text--red' : $publishConfigStore.headerTexts[0].colors === 'blue' ? 'header-text--blue' : $publishConfigStore.headerTexts[0].colors === 'green' ? 'header-text--green' : $publishConfigStore.headerTexts[0].colors === 'orange' ? 'header-text--orange' : ''}
                        ">
                            <span>{ $publishConfigStore.headerTexts[0].text }</span>
                        </div>
                    {/if}
                </div>

            </div>
        {/if}

        <div class="content">

            <h1>{$publishConfigStore.restaurantName}</h1>

            {#if ($publishConfigStore.restaurantDescription)}
                <p class="rest-desc">{$publishConfigStore.restaurantDescription}</p>
            {/if}
        </div>

        {#if ($publishConfigStore.headerActions)}
            <div class="rest-phones">
                {#each $publishConfigStore.headerActions as action}

                    <a class="phone-btn" class:phone-btn--text={action.link === undefined} href="{ action.link }" target="{ action.target }" rel="nofollow noopener">
                        {#if (action.icon === 'phone')}
                            <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="ai ai-Phone"><path d="M10.554 6.24L7.171 2.335c-.39-.45-1.105-.448-1.558.006L2.831 5.128c-.828.829-1.065 2.06-.586 3.047a29.207 29.207 0 0 0 13.561 13.58c.986.479 2.216.242 3.044-.587l2.808-2.813c.455-.455.456-1.174.002-1.564l-3.92-3.365c-.41-.352-1.047-.306-1.458.106l-1.364 1.366a.462.462 0 0 1-.553.088 14.557 14.557 0 0 1-5.36-5.367.463.463 0 0 1 .088-.554l1.36-1.361c.412-.414.457-1.054.101-1.465z"/></svg>
                        {/if}
                        {#if (action.icon === 'location')}
                            <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="ai ai-Location"><circle cx="12" cy="10" r="3"/><path d="M12 2a8 8 0 0 0-8 8c0 1.892.402 3.13 1.5 4.5L12 22l6.5-7.5c1.098-1.37 1.5-2.608 1.5-4.5a8 8 0 0 0-8-8z"/></svg>
                        {/if}
                        {#if (action.icon === 'map')}
                            <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="ai ai-Map"><path d="M8.368 4.79l-2.736-.913A2 2 0 0 0 3 5.775v11.783a2 2 0 0 0 1.368 1.898l4 1.333a2 2 0 0 0 1.264 0l4.736-1.578a2 2 0 0 1 1.264 0l2.736.912A2 2 0 0 0 21 18.224V6.442a2 2 0 0 0-1.367-1.898l-4-1.333a2 2 0 0 0-1.265 0L9.631 4.789a2 2 0 0 1-1.264 0z"/><path d="M9 5v16"/><path d="M15 3v16"/></svg>
                        {/if}
                        {#if (action.icon === 'calendar')}
                            <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="ai ai-Calendar"><rect x="2" y="4" width="20" height="18" rx="4"/><path d="M8 2v4"/><path d="M16 2v4"/><path d="M2 10h20"/></svg>
                        {/if}

                        {#if (action.text && action.text.length > 0)}
                            <span>{ action.text }</span>
                        {/if}
                    </a>

                {/each}
            </div>
        {/if}
    </div>
</header>
